export default "__VITE_ASSET__C4VTWk68__"